import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

class Toggle extends React.Component {
  static propTypes = {
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    name: PropTypes.string,
    showText: PropTypes.bool,
    small: PropTypes.bool,
    theme: PropTypes.string,
    onChange: PropTypes.func.isRequired
  }

  static defaultProps = {
    showText: true,
  }

  checkbox = React.createRef();

  handleClick = () => {
    this.checkbox.current.click();
  }

  render() {
    const { checked, disabled, theme } = this.props;
    const { showText, small, ...validProps } = this.props;
    const className = classNames('toggle', theme, { checked, disabled, small, 'show-text': (showText && !small) });

    return (
      <div className={className} onClick={this.handleClick}>
        <input ref={this.checkbox} type="checkbox" {...validProps} />
        {showText && !small && (<div className="toggle-label">{checked ? 'ON' : 'OFF'}</div>)}
        <div className="toggle-control"/>
      </div>
    );
  }
}

export default Toggle;
